//
import { Session } from '@/shared/util/session';

export const sendKubraAnalytics = (now: number) => {
  Session.set('kubra_posted', now.toString(), true);

  if (typeof window.dataLayer?.push === 'function') {
    window.dataLayer.push({
      event: 'event',
      eventCategory: 'alert',
      eventLabel: 'success',
      eventValue: '1TP kubra submit confirmation',
      timestamp: new Date().toUTCString(),
      userId: Session.get('Q_ci'),
      sessionId: Session.get('X-Correlation-ID'),
    });
  }
};

export const checkKubraPayment = () => {
  const kubraPaymentDateStr = Session.get('kubra_posted', true);
  const kubraPaymentDate: number | undefined = kubraPaymentDateStr
    ? Number(kubraPaymentDateStr)
    : undefined;
  const now = new Date().getTime();

  if (!kubraPaymentDate) return sendKubraAnalytics(now);

  let diff = (now - kubraPaymentDate) / 1000;
  diff /= 60 * 60;
  const hoursDifference = Math.abs(Math.round(diff));

  return hoursDifference >= 24 ? sendKubraAnalytics(now) : undefined;
};
